/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DeliveryStatusList } from '../../models/delivery-status-list';

export interface DeliveryStatusControllerFindAll$Params {

/**
 * Sends 0 to remove limit
 */
  limit: number;
  skip: number;
  description?: string;
  visible?: boolean;

/**
 * Se true, ignora il filtro di visibilità e restituisce anche gli stati eliminati logicamente (visible=false).
 */
  include_invisible?: boolean;
  order_by?: string;
  order_direction?: string;
}

export function deliveryStatusControllerFindAll(http: HttpClient, rootUrl: string, params: DeliveryStatusControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryStatusList;
}>> {
  const rb = new RequestBuilder(rootUrl, deliveryStatusControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('description', params.description, {});
    rb.query('visible', params.visible, {});
    rb.query('include_invisible', params.include_invisible, {});
    rb.query('order_by', params.order_by, {});
    rb.query('order_direction', params.order_direction, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DeliveryStatusList;
      }>;
    })
  );
}

deliveryStatusControllerFindAll.PATH = '/delivery-status';
